export enum ReimbursementType {    
    Wages                           = 1,
    TravelAndLodging                = 2,
    WagesForComplication            = 3,
    TravelAndLodgingForComplication = 4,
    DppReimbursement                = 5,
    DependentCare                   = 6,
    CreditReturnLostWageReimbursement = 7,
    AdvancedReimbursement = 8,
    AdvancedReimbursementPreOp = 9,
    AdvancedReimbursementDonation = 10,
    InternationalWorkup = 11
}